<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="notifications.data"
      :server-items-length="notifications.meta.total"
      :footer-props="footerProps"
      :options.sync="options"
      sort-by="id"
      sort-desc
    >
      <template v-slot:item.dispatch_time="{ item }">
        {{ item.dispatch_time | dateTimeFormat }}
      </template>
      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="$emit('show', item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { dateTimeFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'NotificationList',

  filters: {
    dateTimeFormat
  },

  mixins: [i18nRefreshData],

  data: () => ({
    unwatch: null,
    notifications: {
      meta: {
        total: 0
      }
    },
    options: {},
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    },

    params() {
      const options = this.options;

      return {
        page: options.page,
        per_page: options.itemsPerPage,
        sort_by: options.sortBy[options.sortBy.length - 1],
        order_by: options.sortDesc[options.sortDesc.length - 1] ? 'desc' : 'asc'
      };
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('NOTIFICATIONS.SENDING_TIME'),
          value: 'dispatch_time'
        },
        {
          text: this.$t('NOTIFICATIONS.NUMBER_OF_RECIPIENTS'),
          value: 'users_quantity'
        },
        {
          text: this.$t('ITEM.AUTHOR'),
          value: 'author'
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('notification', ['getList']),

    refreshData() {
      this.getList({ params: this.params })
        .then(({ data }) => {
          this.notifications = data;
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });
    }
  }
};
</script>
